import { Box, Typography } from "@mui/joy";

import { TextField, Textarea } from "../../../../../shared";

export default function CategoryConfiguration() {
    return (
        <Box flex={1}>
            <Box display={"flex"} flexDirection={"column"} gap={1}>
                <TextField
                    name={"Name"}
                    label={"Category Name"}
                    helperText={"Enter the name of the product category"}
                    placeholder={"e.g., Field Shingles, Starter, Hip & Ridge"}
                />
                <Textarea
                    name={"Description"}
                    label={"Description"}
                    helperText={"Optional description of the category"}
                    placeholder={"Describe the purpose and usage of this category..."}
                    minRows={3}
                />
                <TextField
                    name={"DefaultUnitType"}
                    label={"Default Unit Type"}
                    helperText={"Optional default unit type (e.g., SQ, LF, Count)"}
                    placeholder={"e.g., SQ"}
                />
            </Box>
        </Box>
    );
}
